import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL || '';

const EmailVerification = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  
  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [message, setMessage] = useState('');
  
  useEffect(() => {
    verifyEmail();
  }, [token]);
  
  const verifyEmail = async () => {
    try {
      const response = await axios.get(`${API}/api/auth/verify-email/${token}`);
      
      setStatus('success');
      setMessage(response.data.message || 'Email успешно подтвержден!');
      
      // Save token and log in user
      if (response.data.access_token) {
        localStorage.setItem('token', response.data.access_token);
        
        // Reload the page to update auth context
        // This will trigger useEffect in AuthContext to load user data
        setTimeout(() => {
          window.location.href = '/game/profile';
        }, 2000);
      }
    } catch (error) {
      setStatus('error');
      setMessage(
        error.response?.data?.detail || 
        'Ошибка подтверждения email. Возможно, ссылка устарела.'
      );
    }
  };
  
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '2rem'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        padding: '3rem',
        maxWidth: '500px',
        width: '100%',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        textAlign: 'center'
      }}>
        {status === 'verifying' && (
          <>
            <Loader2 
              size={64} 
              style={{ 
                color: '#667eea', 
                animation: 'spin 1s linear infinite',
                margin: '0 auto 1.5rem'
              }} 
            />
            <h2 style={{ 
              fontSize: '1.75rem', 
              fontWeight: 700, 
              color: '#333',
              margin: '0 0 1rem 0'
            }}>
              Подтверждение Email
            </h2>
            <p style={{ color: '#666', fontSize: '1rem' }}>
              Пожалуйста, подождите...
            </p>
          </>
        )}
        
        {status === 'success' && (
          <>
            <CheckCircle 
              size={64} 
              style={{ 
                color: '#10b981', 
                margin: '0 auto 1.5rem'
              }} 
            />
            <h2 style={{ 
              fontSize: '1.75rem', 
              fontWeight: 700, 
              color: '#333',
              margin: '0 0 1rem 0'
            }}>
              Успешно!
            </h2>
            <p style={{ color: '#666', fontSize: '1rem', marginBottom: '1.5rem' }}>
              {message}
            </p>
            <p style={{ color: '#999', fontSize: '0.9rem' }}>
              Перенаправление в ваш профиль...
            </p>
          </>
        )}
        
        {status === 'error' && (
          <>
            <XCircle 
              size={64} 
              style={{ 
                color: '#ef4444', 
                margin: '0 auto 1.5rem'
              }} 
            />
            <h2 style={{ 
              fontSize: '1.75rem', 
              fontWeight: 700, 
              color: '#333',
              margin: '0 0 1rem 0'
            }}>
              Ошибка
            </h2>
            <p style={{ color: '#666', fontSize: '1rem', marginBottom: '1.5rem' }}>
              {message}
            </p>
            <button
              onClick={() => navigate('/login')}
              style={{
                padding: '0.75rem 2rem',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '1rem',
                fontWeight: 600,
                cursor: 'pointer'
              }}
            >
              Перейти к входу
            </button>
          </>
        )}
      </div>
      
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default EmailVerification;
